export default __webpack_public_path__ + "static/IMG_9304-828fd63adb8c30580cfded9f2f068fdb.jpg";